import styled from 'styled-components';
import theme from '../../config/theme';

export const Container = theme.components.containers.main
